import React from 'react';
import Paging from "../../page/Paging";
import AuthorCard from "./AuthorCard";

interface Author {
    authorId: number;
    authorName: string;
    profilePhoto: string;
    authorEmail: string;
    keyword1?: string;
    keyword2?: string;
    introduce?: string;
    writingGenre?: string;
    bookId?: number;
    bookTitle?: string;
    bookGenre1?: string;
    bookGenre2?: string;
    bookOtherCount?: number;
}

interface AuthorCardListProps {
    authorCards: Author[] | undefined;
    moveToAuthor: (author: any) => void;
    formatTitle?: (title: string) => React.ReactNode;
    totalPages: number;
    currentPage: number;
    onPageChange: (page: number) => void;
    emptyMessage?: string;
}

const AuthorList: React.FC<AuthorCardListProps> = ({
    authorCards,
    moveToAuthor,
    totalPages,
    currentPage,
    onPageChange,
    emptyMessage,
}) => {

    if (!authorCards || authorCards.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-16 gap-3">
                <p className="text-[#888] text-[15px] md:text-[13px]">{emptyMessage || "팔로우한 작가가 없습니다."}</p>
            </div>
        );
    }

    return (
        <div>
            <div className="grid grid-cols-4 md:grid-cols-2 gap-4 md:gap-3">
                {authorCards.map((author) => (
                    <AuthorCard
                        key={author.authorId}
                        author={{
                            authorId: author.authorId,
                            authorName: author.authorName,
                            profilePhoto: author.profilePhoto,
                            authorEmail: author.authorEmail,
                            keyword1: author.keyword1,
                            keyword2: author.keyword2,
                            introduce: author.introduce,
                            writingGenre: author.writingGenre,
                            bookId: author.bookId,
                            bookTitle: author.bookTitle,
                            bookGenre1: author.bookGenre1,
                            bookGenre2: author.bookGenre2,
                            bookOtherCount: author.bookOtherCount,
                        }}
                        onClick={moveToAuthor}
                    />
                ))}
            </div>

            <div className="mt-10">
                <Paging
                    totalPages={totalPages}
                    currentPage={currentPage}
                    type="book"
                    onPageChange={onPageChange}
                />
            </div>
        </div>
    );
};

export default AuthorList;
